/**
 * Auto Language Detection
 * Automatically sets the language selector based on browser language
 * NO auto-submit - just pre-selects the dropdown for user to confirm
 */

(function() {
  'use strict';

  // Language mapping - browser language codes to Shopify locale codes
  const languageMapping = {
    'nl': 'nl',      // Dutch
    'nl-NL': 'nl',   // Dutch (Netherlands)
    'nl-BE': 'nl',   // Dutch (Belgium)
    'en': 'en',      // English
    'en-GB': 'en',   // English (UK)
    'en-US': 'en',   // English (US)
    'de': 'de',      // German
    'de-DE': 'de',   // German (Germany)
    'de-AT': 'de',   // German (Austria)
    'de-CH': 'de',   // German (Switzerland)
    'fr': 'fr',      // French
    'fr-FR': 'fr',   // French (France)
    'fr-BE': 'fr',   // French (Belgium)
    'fr-CH': 'fr',   // French (Switzerland)
    'es': 'es',      // Spanish
    'it': 'it',      // Italian
    'pt': 'pt-PT',   // Portuguese
    'pl': 'pl',      // Polish
    'sv': 'sv',      // Swedish
    'da': 'da',      // Danish
    'fi': 'fi',      // Finnish
    'no': 'nb',      // Norwegian
    'nb': 'nb',      // Norwegian Bokmål
  };

  // Get browser language
  function getBrowserLanguage() {
    const lang = navigator.language || navigator.userLanguage || navigator.languages[0];
    return lang || 'nl';
  }

  // Find matching Shopify locale
  function findMatchingLocale(browserLang) {
    // Try exact match first
    if (languageMapping[browserLang]) {
      return languageMapping[browserLang];
    }
    
    // Try language code only (e.g., "nl" from "nl-BE")
    const langCode = browserLang.split('-')[0];
    if (languageMapping[langCode]) {
      return languageMapping[langCode];
    }
    
    // Default to Dutch
    return 'nl';
  }

  // Pre-select language on page load (NO auto-submit)
  function init() {
    // Skip if only one language available
    const langSelectors = document.querySelectorAll('[name="locale_code"]');
    if (langSelectors.length === 0) return;
    
    const browserLang = getBrowserLanguage();
    const targetLocale = findMatchingLocale(browserLang);
    
    // Check if already on correct language
    const currentLocale = document.querySelector('[name="locale_code"]')?.value;
    if (currentLocale === targetLocale) return;
    
    // Find and select matching option (visual only, no submit)
    langSelectors.forEach(function(select) {
      const options = select.querySelectorAll('option');
      options.forEach(function(option) {
        if (option.value === targetLocale) {
          select.value = targetLocale;
        }
      });
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
